var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"user-name",domProps:{"textContent":_vm._s(_vm.user.displayName)},on:{"click":function($event){return _vm.open()}}})}
var staticRenderFns = []

export { render, staticRenderFns }